type LegacySectionSizingData = {
  isCollapsed?: boolean;
  expandedHeight?: number;
  expandedWidth?: number;
};

const LEGACY_COLLAPSED_SECTION_HEIGHT = 1;
const LEGACY_COLLAPSED_SECTION_WIDTH = 250;

const DEFAULT_SECTION_FRAME_WIDTH = 300;
const DEFAULT_SECTION_FRAME_HEIGHT = 200;

function toFinitePositiveNumber(value: unknown): number | undefined {
  if (typeof value !== "number") return undefined;
  if (!Number.isFinite(value) || value <= 0) return undefined;
  return value;
}

function isLegacyCollapsedWidth(width: number | undefined): boolean {
  return width == null || width === LEGACY_COLLAPSED_SECTION_WIDTH;
}

function isLegacyCollapsedHeight(height: number | undefined): boolean {
  return height == null || height === LEGACY_COLLAPSED_SECTION_HEIGHT;
}

function isLegacyCollapsedDimensions(args: {
  width: number | undefined;
  height: number | undefined;
}): boolean {
  const { width, height } = args;

  return isLegacyCollapsedWidth(width) && isLegacyCollapsedHeight(height);
}

export function isSectionMarkedCollapsed(data: unknown): boolean {
  return Boolean((data as LegacySectionSizingData | undefined)?.isCollapsed);
}

export function resolveSectionFrameDimensions(args: {
  width: number | undefined;
  height: number | undefined;
  data: unknown;
}): { frameWidth: number; frameHeight: number } {
  const { width, height, data } = args;
  const sectionData = data as LegacySectionSizingData | undefined;

  let frameWidth = width ?? DEFAULT_SECTION_FRAME_WIDTH;
  let frameHeight = height ?? DEFAULT_SECTION_FRAME_HEIGHT;

  if (!sectionData?.isCollapsed) {
    return { frameWidth, frameHeight };
  }

  const expandedWidth = toFinitePositiveNumber(sectionData.expandedWidth);
  const expandedHeight = toFinitePositiveNumber(sectionData.expandedHeight);
  const isLegacyCollapsed = isLegacyCollapsedDimensions({ width, height });

  if (expandedWidth && isLegacyCollapsed) {
    frameWidth = expandedWidth;
  }

  if (expandedHeight && isLegacyCollapsed) {
    frameHeight = expandedHeight;
  }

  return { frameWidth, frameHeight };
}
